import React, { useState } from 'react';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(''); // '', sending, sent, error
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    try {
      setStatus('sending');
      const response = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await response.json();
      
      if (data.success) {
        setStatus('sent');
        setMessage(data.message);
      } else {
        setStatus('error');
        setMessage(data.message || 'Something went wrong');
      }
    } catch (err) {
      setStatus('error');
      setMessage('Network error. Please try again.');
    }
  };

  const containerStyle = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #0d47a1 0%, #1a73e8 50%, #42a5f5 100%)',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    padding: '20px'
  };

  const cardStyle = {
    background: '#fff',
    borderRadius: '16px',
    padding: '48px 40px',
    maxWidth: '440px',
    width: '100%',
    boxShadow: '0 20px 60px rgba(0,0,0,0.15)'
  };

  const inputStyle = {
    width: '100%', padding: '14px', borderRadius: '8px',
    border: '1px solid #ddd', fontSize: '15px', boxSizing: 'border-box',
    marginBottom: '16px'
  };

  const btnStyle = {
    width: '100%', padding: '14px', borderRadius: '8px',
    background: '#1a73e8', color: '#fff', border: 'none',
    fontSize: '15px', fontWeight: '600', cursor: 'pointer'
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ fontSize: '48px', marginBottom: '12px' }}>🔐</div>
          <h2 style={{ color: '#1a1a1a', marginBottom: '8px' }}>Forgot Password?</h2>
          <p style={{ color: '#666', fontSize: '14px' }}>
            No worries! Enter your email and we'll send you a reset link.
          </p>
        </div>

        {status === 'sent' ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ 
              background: '#e8f5e9', borderRadius: '12px', padding: '24px', marginBottom: '24px' 
            }}>
              <div style={{ fontSize: '32px', marginBottom: '8px' }}>📧</div>
              <p style={{ color: '#2e7d32', fontSize: '15px', lineHeight: '1.5' }}>
                {message}
              </p>
            </div>
            <a href="/login" style={{ color: '#1a73e8', textDecoration: 'none', fontSize: '14px' }}>
              ← Back to Login
            </a>
          </div>
        ) : (
          <>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              style={inputStyle}
              required
            />
            
            {status === 'error' && (
              <p style={{ color: '#c62828', fontSize: '13px', marginBottom: '12px' }}>{message}</p>
            )}
            
            <button
              onClick={handleSubmit}
              disabled={status === 'sending' || !email}
              style={{ ...btnStyle, opacity: (status === 'sending' || !email) ? 0.6 : 1 }}
            >
              {status === 'sending' ? 'Sending...' : 'Send Reset Link'}
            </button>
            
            <p style={{ textAlign: 'center', marginTop: '24px' }}>
              <a href="/login" style={{ color: '#1a73e8', textDecoration: 'none', fontSize: '14px' }}>
                ← Back to Login
              </a>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
